// Copyright (c) 2023 Deere & Company

import DuplicatePinPlateAccordion from './duplicate-pin-plate-accordion';
import actionCreators from '../action-creators';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../../sharedmodules/state/busy-counter';
import { withAuth } from '@okta/okta-react';

const getStateToBindToContainerProps = (state) => ({
    busyCounter: showLoadingIndicator(state.application.busyCounter),
    duplicatePinPlateChanges: state.application.duplicatePinPlateSetting.duplicatePinPlateRequest,

});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const { routeParams } = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps,
        },
        routeParams,
    };

};
export default connect(
    getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp,
)(withAuth(DuplicatePinPlateAccordion));
